<template>
  <div class="container-fluid">
  
  <transition :css="false">
  <el-dialog title="Add Group" :visible.sync="showModal" width="40%">
      <form>
      <p v-show="errorGroup" class="text-danger text-center font-weight-bold">Group Name and Group Description are required!</p>
        <div class="form-group">
          <label>Group Name</label>
          <input type="text" v-model="form.groupname" style="height:5rem" class="form-control"
 />
        </div><br />

        <div class="form-group">
          <label for="exampleFormControlTextarea1">Group Description</label>
          <textarea
            v-model="form.group_desc"
            class="form-control"
            id="exampleFormControlTextarea1"
            rows="3"
          ></textarea>
        </div>

        <div class="mt-5 form-check ml-3">
          <input
            class="form-check-input"
            v-model="form.status"
            type="checkbox"
            value=""
            id="defaultCheck1"
          />
          <label class="form-check-label" for="defaultCheck1">
            {{ form.status ? 'Disable Group' : 'Enable Group' }}
          </label>
        </div>
        <div class="pt-4 text-right">
          <div v-if="loader" className="text-center">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem;"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div v-else>
            <button class="btn btn-primary" @click="createGroup">
              Create Group
            </button>
          </div>
        </div>
      </form>
    </el-dialog>
    </transition>
    
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>New User</h3>
        <hr />
      </div>
    </vk-offcanvas>
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Group</h2>
        <can I="create" a="user">
          <span style="display: flex; align-items: center;">
            <button
              class="btn btn-primary"
              to="/user/new"
              @click="showModal2 = true"
            >
              New Group
            </button>
          </span>
        </can>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <can I="read" a="user">
              <Users />
            </can>
            <el-tabs v-model="activeTab">
              <!-- <can I="read" a="user">
                <el-tab-pane label="User List" name="user_list">
                  <Users/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="device">
                <el-tab-pane label="User Devices" name="user_devices">
                  <Devices/>
                </el-tab-pane>
              </can>-->
              <!-- <can I="read" a="wallet">
                <el-tab-pane label="Transaction History" name="transaction_history">
                  <transaction-histories/>
                </el-tab-pane>
              </can>-->
              <!-- <can I='read' a='user'>
                  <el-tab-pane title="User Role Management">
                  <user-role/>
                  </el-tab-pane>
              </can>-->
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Users from "../user-mgt/GroupInfo";
import Devices from "../devices/List";
import transactionHistories from "../shs/Wallet";
import userRole from "../users/allow";
import ModalMain from "../kitchen/Onboarding/ModalMain.vue";
import ArnergyInput from "../kitchen/ArnergyInput.vue";
import VueSweetalert2 from 'vue-sweetalert2';
import Vue from 'vue'
import 'sweetalert2/dist/sweetalert2.min.css';

import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";

export default {
  name: "",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    Users,
        VueSweetalert2,
    Devices,
    transactionHistories,
    userRole,
    ArnergyInput,
    ModalMain,
  },
  data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      showModal2: false,
      loader:false,
      errorGroup:false,
      form: {
        groupname: null,
        group_desc: null,
        status: false,
      },
      formErrors: {
        groupname: "",
        group_desc: "",
      },
    };
  },
  computed: {},
  methods: {
    validateInputs() {
      const formErrors = [];

      //
      for (let [field, value] of Object.entries(this.form)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "groupname":
            if (value === "null" || value === "") {
              formErrors[field] = "Group Name cannot be empty.";
            }
            break;
          case "group_desc":
            if (value === "null" || value === "") {
              formErrors[field] = "Group Description cannot be empty.";
            }
            break;

          default:
            break;
        }
      }
      return formErrors;
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({title: 'Success', imageWidth: '40px', text: 'Group Created Successfully', icon:'success', width: '550px'});
    },

    createGroup(e) {
      e.preventDefault();
      const data = {
        groupname: this.form.groupname,
        groupdesc: this.form.group_desc,
        status: this.form.status ? 1 : 0,
      };
      console.log(data)
      const HTTP = this.$httpUtils.instance;
      if(data.groupname && data.groupdesc ){
      this.loader = true;
      HTTP.post(
              "/customerGroups",
              data
            ).then(res => {
             if(res.data){
               this.showModal2 = false
               this.showAlert()
               this.loader = false;
               this.fetchUsers()
               this.form.groupname = null;
               this.form.group_desc = null;
               this.form.status = false;
             }
            })
            .catch((err) => {
                console.log(err)
            })
            return;
      }
      if(data.groupname == null && data.groupdesc == null ){
        this.errorGroup = true;
        setTimeout(() => this.errorGroup = false, 1500);

        return;
      }

    },
    closeModal(){
       this.form.groupname = "";
               this.form.group_desc ="";
               this.form.status = false;
               this.showModal2= false

    },
      fetchUsers() {
      const HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      const url = `/customerGroups
`;
      HTTP.get(url)
        .then((response) => {
          const usersList = response.data;
          this.$store.commit("saveGroups", usersList.map((data) => ({
            id: data.id,
            groupname: data.groupname,
            groupdesc: data.groupdesc,
            status: data.status == 0 ? "Disabled" : "Enabled"
          })));
          // console.log(this.getUserById(1))
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    
  },
   mounted() {
    //  console.log(this.getUserSession);
    const httpUtils = this.__proto__.__proto__.$httpUtils;
    // this.access = 'CUSTOMER'
    // console.log(this.$ability);
  }
};
</script>

<style lang="scss" scoped>
.close-btn {
  color: orangered;
  font-size: 16px;
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/user-mgt/Group.vue